import colors from "~constants/colors"
import { FormElement, FormField, FormSection } from "~shapes/dynamicForm"
import InputGenerator from "./dynamic/InputGenerator"
import { useForm, useFormContext } from "react-hook-form"
import { Form, FormSubmit } from "~styled/form"

interface Props {
  data: any
}

const DynamicForm = ({ data }: Props) => {
  const {
    control,
    register,
    formState: { errors },
    getValues,
    setValue,
    unregister,
  } = useFormContext()

  return (
    <>
      <div>
        {data?.form[0]?.name && (
          <h4 color={colors.black}>{data?.form[0]?.name}</h4>
        )}
      </div>
      <div style={{ flexDirection: "column", flex: 1, minWidth: 400 }}>
        <Form>
          {data?.form.map((e: FormElement) =>
            e.sections.map((f: FormSection) =>
              f.fields.map((field: FormField, idx: number) => (
                <div style={{ marginTop: 15 }} key={idx}>
                  <InputGenerator
                    key={idx}
                    field={field}
                    control={control}
                    errors={errors}
                    register={register}
                    getValues={getValues}
                    setValue={setValue}
                    unregister={unregister}
                  />
                </div>
              )),
            ),
          )}
        </Form>
      </div>
    </>
  )
}

export default DynamicForm
